// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//全局路由拦截
import "./GlobalRouteInterception";

//全局配置首行缩进编辑器
import "./common/AlertMenu";

//element-ui 引入
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)
Vue.config.productionTip = false
//引入对项目初始文件
import './assets/css/reset.css'

//引入字体
// import './assets/css/font.css'


//iconfont .css .js
// import "./assets/css/iconfont.css"
// import "./assets/js/iconfont"
//图片放大
import VueImageView from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueImageView, {
  zIndex: '2019'  /*弹框的图片级别设置高点 才能在最上层 看的到 更多参数见文档*/
})
// 裁剪图片
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
//引入状态管理
import store from './store/index'
//动画引入
import 'animate.css'
//swiper引入js、css
import 'swiper/js/swiper.min'
import 'swiper/css/swiper.min.css'

//引入echarts
// import * as echarts from 'echarts'
// Vue.prototype.$echarts = echarts;

// 引入百度地图
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
      /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
      ak: '6fHB83ebSOF8eSZUDcuNj0xMtR5XHhKU'
})

//引入全局过滤器
import comFilter from './filter/index'
for(let i in comFilter){
  Vue.filter(i,comFilter[i])
}

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js